import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { useId } from "react-id-generator";
import useAuiGridMethods from "../../../hooks/AuiGrid/useAuiGridMethods";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { columnLayout, columnLayoutItem } from "./conlumnLayout";

const ReturnListPop = ({ onResolve, vhclNo }) => {
  const [gridId] = useId(1, "aui-grid-");
  const [gridItemId] = useId(1, "aui-grid-");
  let auiGrid = useAuiGridMethods(gridId);
  let auiGridItem = useAuiGridMethods(gridItemId);

  const [show, setShow] = useState(true);

  //배차지시서 검색 URL
  const SERARCH_RETURNLIST_URL = "/inspection/video/searchReturnList.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_RETURNLIST_URL,
    },
    { manual: true }
  );

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    auiGrid.create(columnLayout, {
      ...defaultGridProps,
      // 엑스트라 행 체크박스(showRowCheckColumn=true)를 설정한 경우, 헤더 부분에 전체 선택 체크박스를 표시할지 여부를 지정합니다.
      // 기본값(default) : true.
      showRowAllCheckBox: false,

      // 엑스트라 행 체크박스 출력 여부를 지정합니다.
      // 이 속성 값이 true 이면 최좌측에 체크박스 칼럼이 생성됩니다.
      // 기본값(default) : false.
      showRowCheckColumn: false,
    });

    handleSearch();
  }, []);

  const handleClose = (returnData) => {
    setShow(false);
  };

  const handleOk = (returnData) => {
    setShow(false);
  };

  const handleSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_RETURNLIST_URL,
      params: {
        vhclNo: vhclNo,
      },
    });
    auiGrid.setGridData(data);
  };

  window.onresize = function () {
    // 크기가 변경되었을 때 AUIGrid.resize() 함수 호출
    if (typeof auiGrid !== "undefined") {
      auiGrid.resize();
    }
  };
  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)} size="clg">
        <Modal.Header closeButton>
          <Modal.Title>반품/경고내역 검색</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ width: "100%" }}>
            <div id={gridId} style={{ height: 300 }} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose(false)}>
            취소
          </Button>

          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalReturnListPop = createModal(ReturnListPop);

export default ReturnListPop;
